<template>
  <section>
    <AprobarUsoJefeSuperiorJerarquico />
    <ReprogramarJefeSup />
    <VerSeguimientoJefeSup />
    <VerDetalle />
    <VerDetalleUsoVacacion />
    <AprobarReprogramacionVacacionSuperior />
    <VerReprogramaciones />
    <RechazarReprogramacionJefe />
    <!-- Componentes externos PAPELETAS CON CARGO A VACACION-->
    <VerPermiso />
    <AprobarPermiso />
    <RechazarPermiso />
    <h3 class="primary--text">
      <v-icon color="primary">people</v-icon>
      Aprobación/Rechazo de vacaciones
    </h3>
    <!-- Seleccionar gestion   @change="cargarFuncionarios(periodo_seleccionado)"-->
    <v-flex xs12 md6>
      <v-autocomplete
        :items="lista_gestiones"
        item-text="periodo"
        item-value="periodo"
        label="Seleccione la gestión"
        v-model="periodo_seleccionado"
        @change="actualizaCrudTable()"
        required
        outline
        success
        clearable
      ></v-autocomplete>
    </v-flex>
    <v-card elevation="0">
      <v-card-text class="text-xs-center" v-if="loading_tabla">
        <v-progress-circular
          :size="100"
          :width="10"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-if="!loading_tabla">
        <v-layout>
          <!-- Boton filtro -->
          <v-tooltip bottom>
            <v-btn
              @click.native="
                () => {
                  filterShow = !filterShow;
                }
              "
              class="btn-refresh"
              slot="activator"
              ><v-icon>filter_list</v-icon>
            </v-btn>
            <span>Búsqueda/filtros</span>
          </v-tooltip>
          <!-- Boton acutualizar -->
          <v-tooltip bottom>
            <v-btn
              @click.native="cargarFuncionarios(periodo_seleccionado)"
              class="btn-refresh"
              slot="activator"
              ><v-icon>refresh</v-icon>
            </v-btn>
            <span>{{ $t("common.updateList") }}</span>
          </v-tooltip>
        </v-layout>
        <v-flex xs12>
          <transition name="slide-fade">
            <div class="filter-container-rrhh" v-show="filterShow">
              <v-icon small color="primary">search</v-icon>
              <div class="filter-item">
                <v-text-field
                  label="Nro"
                  type="number"
                  v-model="form.numero"
                  @input="filterNumero"
                ></v-text-field>
              </div>

              <div class="filter-item">
                <v-text-field
                  label="Nombre"
                  single-line
                  hide-details
                  @input="filterNombres"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Unidad"
                  single-line
                  hide-details
                  @input="filterNombreUnidad"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha desde"
                  single-line
                  hide-details
                  @input="filterFechaDesde"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha hasta"
                  single-line
                  hide-details
                  @input="filterFechaHasta"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Días programados"
                  type="number"
                  v-model="form.dias"
                  @input="filterDias"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Tipo"
                  single-line
                  hide-details
                  @input="filterTipo"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Estado"
                  single-line
                  hide-details
                  @input="filterEstado"
                ></v-text-field>
              </div>
              <div class="filter-item">
                <v-text-field
                  label="Fecha solicitud"
                  v-model="form.fecha_solicitud"
                  @input="filterFechaSolicitud"
                ></v-text-field>
              </div>
              <!-- botones cerrar -->
              <div class="btn-filter">
                <v-tooltip bottom>
                  <v-btn icon small slot="activator" @click.native="recargar()">
                    <v-icon small>refresh</v-icon>
                  </v-btn>
                  <span>Recargar filtros</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn
                    icon
                    slot="activator"
                    @click.native="
                      () => {
                        filterShow = false;
                      }
                    "
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                  <span>Cerrar filtros</span>
                </v-tooltip>
              </div>
            </div>
          </transition>
        </v-flex>
        <br />
        <v-data-table
          v-if="sw_crud_table"
          class="elevation-1 tabla-comprimida-light"
          :headers="headers"
          :items="lista_personas"
          no-data-text="Sin datos"
          item-key="id"
          :search="filters"
          :custom-filter="customFilter"
          no-results-text="No se encontro coincidencias"
          :rows-per-page-items="[25, 50, { text: 'Todos', value: -1 }]"
          :disable-initial-sort="true"
        >
          <template v-slot:items="items">
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.numero }}
            </td>

            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.nombres.replace(/(')/gm, "") }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.nombre_unidad }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.fecha_desde }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.fecha_hasta }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.dias }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.tipo }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{
                items.item.estado && items.item.id_estado == 7
                  ? "Aprobada Inmediato Superior"
                  : items.item.estado
                  ? items.item.estado
                  : ""
              }}
            </td>
            <td
              class="text-xs-center"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              {{ items.item.fecha_solicitud }}
            </td>
            <td
              v-if="
                items.item.tipo == 'P' ||
                  items.item.tipo == 'R' ||
                  items.item.tipo == 'FR'
              "
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              <v-btn
                color="#6DE0BA"
                @click.prevent="verDetalle(items.item)"
                icon
                title="Ver seguimiento"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <!-- VACACIONES REPROGRAMADAS-->
              <!-- <v-btn
                v-if="items.item.id_estado == 57"
                color="#44deaa"
                @click.prevent="verReprogramaciones(items.item)"
                icon
                title="Ver detalle de reprogramaciones"
              >
                <v-icon>today</v-icon>
              </v-btn> -->
              <!--  aprobacion del uso de LA VACACION
                 v-if="items.item.id_estado=='58'"-->
              <v-btn
                v-if="
                  (items.item.id_estado == '58' ||
                    items.item.id_estado == '55') &&
                    user.id_persona == items.item.id_jefe_ultimo &&
                    bandera_fecha_corte
                "
                color="#44deaa"
                @click.prevent="aprobarUsoSuperiorJerarquico(items.item)"
                icon
                title="Aprobar uso de vacación"
              >
                <v-icon>done</v-icon>
              </v-btn>

              <!--  rechazar uso de VACACION-->
              <!-- v-if="
                  (items.item.id_estado == '58' ||
                    items.item.id_estado == '55') &&
                  items.item.tipo == 'P' &&
                  !items.item.id_padre && bandera_fecha_corte
                " -->

              <v-btn
                v-if="
                  (items.item.id_estado == '58' ||
                    items.item.id_estado == '55') &&
                    user.id_persona == items.item.id_jefe_ultimo &&
                    bandera_fecha_corte &&
                    items.item.tipo != 'R'
                "
                color="#FF5D34"
                @click.prevent="reprogramarJefeSup(items.item)"
                icon
                title="Reprogramar"
              >
                <v-icon>close</v-icon>
              </v-btn>
              <!--  aprobacion de la reprogramacion DE LA VACACION || (items.item.id_estado == 57 &&
                  items.item.id_estado_hijo != 70 &&
                  (items.item.id_estado_hijo == 68 ||
                    items.item.id_estado_hijo == 69) && items.item.id_jefe_ultimo_hijo==user.id_persona)-->
              <v-btn
                v-if="
                  items.item.id_estado == 57 &&
                    items.item.id_estado_hijo != 70 &&
                    (items.item.id_estado_hijo == 68 ||
                      items.item.id_estado_hijo == 69) &&
                    (items.item.tipo == 'FR' || items.item.tipo == 'P') &&
                    bandera_fecha_corte
                "
                color="#a87af3"
                @click.prevent="
                  aprobarReprogramacionVacacionSuperior(items.item)
                "
                icon
                title="Aprobar reprogramación de vacación ."
              >
                <v-icon>done</v-icon>
              </v-btn>
              <!-- Rechazar reprogramacion y editarla nuevamente  && items.item.id_jefe_ultimo_hijo==user.id_persona-->
              <v-btn
                v-if="
                  items.item.id_estado_hijo &&
                    (items.item.id_estado_hijo == 68 ||
                      items.item.id_estado_hijo == 69) &&
                    bandera_fecha_corte
                "
                color="#FF5D34"
                @click.prevent="rechazarReprogramacion(items.item)"
                icon
                title="Rechazar reprogramación"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </td>
            <!-- ------------------------------------------------- BOTONES PAPELETAS CON CARGO A VACACION---------------------------------------------->
            <td
              v-if="items.item.tipo == 'VC'"
              :id="
                items.item.tipo == 'P'
                  ? 'celdaP'
                  : items.item.tipo == 'R'
                  ? 'celdaR'
                  : items.item.tipo == 'VC'
                  ? 'celdaVC'
                  : 'celdaFR'
              "
            >
              <v-btn
                color="info"
                @click.prevent="verPermiso(items.item)"
                icon
                title="Ver vacacion"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>

              <!-- btn de aprobacion-->
              <v-btn
                v-if="
                  items.item.id_estado == 6 ||
                    items.item.id_estado == 21 ||
                    items.item.id_estado == 7
                "
                color="success"
                @click.prevent="aprobarPermiso(items.item)"
                icon
                title="Aprobar permiso"
              >
                <v-icon>done</v-icon>
              </v-btn>

              <v-btn
                v-if="
                  items.item.id_estado == 6 ||
                    items.item.id_estado == 21 ||
                    items.item.id_estado == 7
                "
                color="red"
                dark
                @click.prevent="rechazarPermiso(items.item)"
                icon
                title="Rechazar permiso"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import AprobarUsoJefeSuperiorJerarquico from "./dialogs/AprobarUsoJefeSuperiorJerarquico.vue";
import FiltrosVacacion from "../vacacion_rrhh/mixins/FiltrosVacacion";
import ReprogramarJefeSup from "./dialogs/ReprogramarJefeSup.vue";
import VerSeguimientoJefeSup from "./dialogs/VerSeguimientoJefeSup.vue";
import VerDetalle from "../vacacion_rrhh/dialogs/VerDetalle.vue";
import VerDetalleUsoVacacion from "../vacacion_rrhh/dialogs/VerDetalleUsoVacacion.vue";
import AprobarReprogramacionVacacionSuperior from "./dialogs/AprobarReprogramacionVacacionSuperior.vue";
import RechazarReprogramacionJefe from "./dialogs/RechazarReprogramacionJefe";
import VerReprogramaciones from "./dialogs/VerReprogramaciones";
//Componentes externos PAPELETAS CON CARGO A VACACION-->
import VerPermiso from "../vacacion_rrhh/dialogs/VerPermiso.vue";
import AprobarPermiso from "./dialogs/AprobarPermiso";
import RechazarPermiso from "./dialogs/RechazarPermiso";
export default {
  mixins: [crud, FiltrosVacacion],
  data() {
    return {
      //active: "datos-personales-basicos",
      form: {},
      sw_crud_table: true,
      loading_tabla: true,
      persona: null,
      loading: false,
      img_url: "",
      funcionario: null,
      selected: [],
      selected_uso: [],
      filterShow: true,
      filters: {
        numero: "",
        fecha_desde: "",
        fecha_hasta: "",
        dias: "",
        tipo: "",
        estado: "",
        fecha_solicitud: "",
        nombre_unidad: "",
        nombres: "",
        bandera_fecha_corte: true,
        user: this.$storage.get("user")
      },
      graphql: true,
      // Cabecera de la tabla
      initData: [
        {
          state: true,
          param: "id_jefe",
          value: this.$storage.get("user").id_persona
        }
      ],
      headers: [
        {
          text: "Número",
          value: "numero",
          align: "center",
          class: "header"
        },

        {
          text: "Nombre",
          value: "nombre",
          align: "center",
          class: "header"
        },
        {
          text: "Unidad",
          value: "nom_uni",
          align: "center",
          class: "header"
        },
        {
          text: "Fecha desde",
          value: "fecha_desde",
          align: "center",
          class: "header"
        },
        {
          text: "Fecha hasta",
          value: "fecha_hasta",
          align: "center",
          class: "header"
        },
        {
          text: "Días programados",
          value: "dias",
          align: "center",
          class: "header"
        },
        {
          text: "Tipo",
          value: "tipo",
          align: "center",
          class: "header"
        },
        {
          text: "Estado",
          value: "estado",
          align: "center",
          class: "header"
        },
        {
          text: "Fecha de solicitud",
          value: "fecha_solicitud",
          align: "center",
          class: "header"
        },
        {
          text: this.$t("common.actions"),
          sortable: false,
          align: "center",
          class: "header"
        }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
         id
        id_jefe
        id_estado
        fecha_desde
        fecha_hasta
        fecha_solicitud
        id_persona
        nro_doc
        funcionario
        estado
        total_dias
        unidad
        id_unidad

      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      lista_gestiones: [],
      periodo_seleccionado: new Date().getFullYear(),
      lista_personas: [],
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      persona: null,
      saldo: null,
      periodo: null,
      user: this.$storage.get("user"),
      id_programacion: null
    };
  },
  async mounted() {
    await this.obtenerListaGestiones();
    await this.obtenerFechaCorte();

    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    await this.cargarFuncionarios(this.periodo_seleccionado);
    this.onFilter();
    this.$bus.$on("closeDialogReprogramarJefeSup", async () => {
      await this.cargarFuncionarios(this.periodo_seleccionado);
    });
    this.$bus.$on("closeDialogAprobarUsoJefeSuperiorJerarquico", async () => {
      await this.cargarFuncionarios(this.periodo_seleccionado);
      this.onFilter();
    });
    this.$bus.$on("closeDialogAprobarPapJefeI", async () => {
      await this.cargarFuncionarios(this.periodo_seleccionado);
    });
    this.$bus.$on(
      "closeDialogAprobarReprogramacionVacacionSuperior",
      async () => {
        await this.cargarFuncionarios(this.periodo_seleccionado);
        this.onFilter();
      }
    );
    this.$bus.$on("closeDialogVerDetalleUsoFuncionarioRRHH", () => {});
    this.$bus.$on("closeDialogVerDetalleUsoFuncionarioNormalRRHH", () => {});
    this.$bus.$on("closeDialogVerDetalleUsoFuncionario", () => {});
    this.$bus.$on("closeDialogVerSeguimientoJefeSup", async () => {});
    this.$bus.$on("closeDialogRechazarReprogramacionJefe", async () => {
      await this.cargarFuncionarios(this.periodo_seleccionado);
      this.onFilter();
    });
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
  },

  methods: {
    // Metodo para actualizar el crud table con una gestion
    async actualizaCrudTable() {
      if (!this.periodo_seleccionado) {
        return;
      }
      this.sw_crud_table = false;
      await new Promise(resolve => setTimeout(resolve, 100));
      await this.cargarFuncionarios(this.periodo_seleccionado);
      this.sw_crud_table = true;
    },
    //metodo para obtener las gestiones:
    async obtenerListaGestiones() {
      const user = this.$storage.get("user");
      try {
        this.lista_gestiones = [{ periodo: 2023 }, { periodo: 2024 }, { periodo: 2025 }, { periodo: 2026 }];
      } catch (error) {
        console.log(error);
      }
    },
    aprobarUsoSuperiorJerarquico(item) {
      item.nombres = item.nombres.replace(/(')/gm, "");
      this.$bus.$emit("openDialogAprobarUsoJefeSuperiorJerarquico", item);
    },
    aprobarReprogramacionVacacionSuperior(item) {
      item.nombres = item.nombres.replace(/(')/gm, "");
      this.$bus.$emit("AprobarReprogramacionVacacionSuperior", item);
    },
    reprogramarJefeSup(item) {
      item.nombres = item.nombres.replace(/(')/gm, "");
      this.$bus.$emit("openDialogReprogramarJefeSup", item);
    },
    verSeguimientoJefeSup(item) {
      item.nombres = item.nombres.replace(/(')/gm, "");
      this.$bus.$emit("openDialogVerSeguimientoJefeSup", item);
    },
    verDetalle(item) {
      item.nombres = item.nombres.replace(/(')/gm, "");
      if (item.tipo == "P") {
        this.$bus.$emit("openDialogVerDetalleUsoVacacionRRHH", item);
      } else {
        this.$bus.$emit("openDialogVerDetalleUsoFuncionarioNormalRRHH", item);
      }
    },
    verReprogramaciones(item) {
      this.$bus.$emit("openDialogVerReprogramaciones", item);
    },
    //metodo para obtenr la fecha de corte de programacion devsacacaiones:
    async obtenerFechaCorte() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select case when now()::date between vp.fecha_corte and coalesce (vp.fecha_aprobacion,now()::date) then false else true end valor from vacaciones.v_programacion vp where vp.gestion =(select max(vp.gestion) from vacaciones.v_programacion vp)"){
                  respuesta
                  }
                }	
              `
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          if (respuesta.runQuery.respuesta[0].valor == true) {
            this.bandera_fecha_corte = true;
            return;
          } else {
            this.bandera_fecha_corte = false;
            return;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    // Metodo para cargar el listado de unidades
    async cargarFuncionarios(periodo) {
      let user = this.$storage.get("user");
      this.lista_personas = [];
      try {
        let res = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"select * FROM vacaciones.v_vac_programacion_reprogramacion_a_cuenta_vacacion vvp WHERE vvp.id_jefe=${parseInt(
                    this.user.id_persona
                  )} and vvp.gestion=${parseInt(
            periodo
          )} and (vvp.id_estado not in (22,51,73,66,54,67,68,69,71,9,47,72) or(vvp.id_estado=71 and vvp.tipo='FR'))  order by orden,fecha_actualizacion desc"){
                  respuesta
                  }
                }	
          `
        });
        if (res.runQuery.respuesta.length > 0) {
          let lista_unidades_pre = res.runQuery.respuesta;
          this.lista_personas = lista_unidades_pre;
          // // lista_unidades_pre.forEach((element) => {
          // //     lista_personal.push(element);
          // // });
          // // Ordenamos la lista
          // // Separamomos negativos y positivos
          // var lista_nega = [];
          // var lista_posi = [];
          // lista_unidades_pre.forEach(element => {
          //   if (element.dias_faltantes < 0) {
          //     lista_nega.push(element);
          //   } else {
          //     lista_posi.push(element);
          //   }
          // });
          // // Ordenamos lista nega descendentemente
          // lista_nega.sort(function(a, b) {
          //   if (a.dias_faltantes < b.dias_faltantes) {
          //     return 1;
          //   }
          //   if (a.dias_faltantes > b.dias_faltantes) {
          //     return -1;
          //   }
          //   return 0;
          // });
          // // Ordenamos lista posi ascendentemente
          // lista_posi.sort(function(a, b) {
          //   if (a.dias_faltantes > b.dias_faltantes) {
          //     return 1;
          //   }
          //   if (a.dias_faltantes < b.dias_faltantes) {
          //     return -1;
          //   }
          //   return 0;
          // });
          // // unimos listas
          // this.lista_personas = lista_posi.concat(lista_nega);
        }
        this.loading_tabla = false;
      } catch (error) {
        console.log(error);
      }
    },
    getAño() {
      let año = new Date().getFullYear() + "";
      return año;
    },

    getId(id) {
      let sw = false;
      let index;
      for (let i = 0; i < this.selected.length; i++) {
        const element = this.selected[i];
        if (id == element) {
          sw = true;
          index = i;
          break;
        }
      }
      if (sw == true) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(id);
      }

      return sw;
    },
    // Selecciona o desmarcar checkbox aprobacion uso de vacacion
    getIdUso(id) {
      let sw = false;
      let index;
      for (let i = 0; i < this.selected_uso.length; i++) {
        const element = this.selected_uso[i];
        if (id == element) {
          sw = true;
          index = i;
          break;
        }
      }
      if (sw == true) {
        this.selected_uso.splice(index, 1);
      } else {
        this.selected_uso.push(id);
      }
      return sw;
    },
    async seleccionarTodo() {
      let usuario = this.$storage.get("user").id_persona;
      let lista_seleccion = [];
      let resp = await this.$service.graphql({
        query: `
          query{
            vVacasPendientesMayorAJefes(lista_estados:"44,51",id_jefe:${usuario}){
              rows {
               id
                  id_jefe
                  id_estado
                  fecha_desde
                  fecha_hasta
                  fecha_solicitud
                  id_persona
                  nro_doc
                  funcionario
                  estado
                  total_dias
                
              }
            }
          }
        `
      });

      lista_seleccion = resp.vVacasPendientesMayorAJefes.rows;

      for (let index = 0; index < lista_seleccion.length; index++) {
        const element = lista_seleccion[index];

        let sw = false;
        for (let i = 0; i < this.selected.length; i++) {
          const element2 = this.selected[i];
          if (element.id == element2) {
            sw = true;
            break;
          }
        }
        if (!sw) {
          this.selected.push(element.id);
        }
      }
    },
    async seleccionarTodoUso() {
      let usuario = this.$storage.get("user").id_persona;
      let lista_seleccion = [];
      let resp = await this.$service.graphql({
        query: `
          query{
            vVacasPendientesMayorAJefes(lista_estados:"55,58",id_jefe:${usuario}){
              rows {
                id
                id_jefe
                id_estado
                fecha_desde
                fecha_hasta
                fecha_solicitud
                id_persona
                nro_doc
                funcionario
                estado
                total_dias
                
              }
            }
          }
        `
      });
      lista_seleccion = resp.vVacasPendientesMayorAJefes.rows;
      for (let index = 0; index < lista_seleccion.length; index++) {
        const element = lista_seleccion[index];
        let sw = false;
        for (let i = 0; i < this.selected_uso.length; i++) {
          const element2 = this.selected_uso[i];
          if (element.id == element2) {
            sw = true;
            break;
          }
        }
        if (!sw) {
          this.selected_uso.push(element.id);
        }
      }
    },
    deseleccionarTodo() {
      this.selected = [];
      this.selected_uso = [];
    },

    verifica(id) {
      return this.selected.includes(id);
    },
    verifica_uso(id) {
      return this.selected_uso.includes(id);
    },
    verReporte(item, valor) {
      item.reprogramacion = valor; //programacion=0,repro=1
      this.$bus.$emit("openDialogVerReporte", item);
    },
    getIdPersona() {
      const user = this.$storage.get("user");
      let id_persona = user.id_persona;
      return id_persona;
    },
    rechazarReprogramacion(item) {
      this.$bus.$emit("openDialogRechazarReprogramacionJefe", item);
    },
    // <!-- ------------------------------------------------- FUNCONES PAPELETAS CON CARGO A VACACION---------------------------------------------->
    aprobarPermiso(item) {
      item.nivel_jefe = 2;
      this.$bus.$emit("openDialogAprobarPermisoCtaVacacionJefeI", item);
    },

    rechazarPermiso(item) {
      this.$bus.$emit("openDialogRechazarPermisoCtaVacacionJefeI", item);
    },
    verPermiso(item) {
      this.$bus.$emit("openDialogVerPermisoRRHH", item);
    }
  },
  components: {
    CrudTable,
    AprobarUsoJefeSuperiorJerarquico,
    ReprogramarJefeSup,
    VerSeguimientoJefeSup,
    VerDetalleUsoVacacion,
    VerDetalle,
    AprobarReprogramacionVacacionSuperior,
    VerReprogramaciones,
    AprobarPermiso,
    RechazarPermiso,
    VerPermiso,
    RechazarReprogramacionJefe
  }
};
</script>
<style>
.header {
  white-space: pre;
  word-wrap: break-word;
  background: rgba(0, 165, 151, 0.438);
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
  border: solid 0.0001em rgba(65, 144, 150, 0.589);
}
#celdaP {
  background: rgba(103, 236, 179, 0.3);
}
#celdaR {
  background: rgba(241, 217, 111, 0.3);
}
#celdaVC {
  background: rgba(189, 143, 238, 0.3);
}
#celdaFR {
  background: rgba(141, 208, 240, 0.3);
}
.v_card {
  margin: 0em 0em 0em 0em;
  padding: 0em 1em 0em 1em;
}
#sin_margen2 {
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
}
h3 {
  color: rgb(1, 3, 85);
}
.expandir {
  min-width: 100%;
}
#celda {
  background: rgba(168, 255, 236, 0.288);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/VacacionUsoJefeSuperior.vue